// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  background-color: #242937;
  border: 1px solid #f09500;
  border-radius: 10px;
  color: white;
}

.card-title {
  font-weight: 600;
  color: #f09500;
}

.btn-outline-warning {
  color: #f09500;
  border-color: #f09500;
}

.btn-outline-warning:hover {
  background-color: #f09500;
  color: #242937;
}

.btn-warning {
  background-color: #f09500;
  border-color: #f09500;
  color: #242937;
}

.btn-primary {
  background-color: #007bff !important;
  border-color: #007bff !important;
  color: white !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.btn-primary:hover {
  background-color: #0056b3 !important;
  border-color: #0056b3 !important;
  color: white !important;
}

.btn-primary:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: white !important;
  opacity: 0.65 !important;
  cursor: not-allowed !important;
}

.table {
  color: white;
}

.table thead th {
  font-weight: 600;
  border-color: #3a3f50;
}

.table tbody td {
  vertical-align: middle;
  border-color: #3a3f50;
}

.text-warning {
  color: #f09500 !important;
}

.badge {
  padding: 8px;
  font-weight: 500;
}

.btn-success, .btn-danger {
  border: none;
}

.btn-success {
  background-color: #28a745;
}

.btn-danger {
  background-color: #dc3545;
}

.alert-info {
  background-color: rgba(13, 202, 240, 0.2);
  color: white;
  border-color: transparent;
}

.cursor-pointer {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.cursor-pointer:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Estilos para mejorar la apariencia de los botones en la tabla */
.table td {
  vertical-align: middle;
}

/* Contenedor de botones - forzar disposición horizontal */
.actions-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
  min-width: 220px;
}

/* Cuando los botones necesiten wrap, hacerlo con mejor control */
@media (max-width: 1200px) {
  .actions-container {
    flex-wrap: wrap;
    min-width: 180px;
  }
}

.actions-container .btn {
  white-space: nowrap;
  font-size: 0.75rem;
  padding: 0.25rem 0.4rem;
  border-radius: 4px;
  margin: 1px;
}

/* Colores específicos para cada tipo de botón */
.actions-container .btn-success {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

.actions-container .btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.actions-container .btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #212529;
}

.actions-container .btn-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: white;
}

.actions-container .btn-primary {
  background-color: #007bff !important;
  border-color: #007bff !important;
  color: white !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.actions-container .btn-primary:hover {
  background-color: #0056b3 !important;
  border-color: #0056b3 !important;
  color: white !important;
}

.actions-container .btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  background-color: transparent;
}

.actions-container .btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

/* Badge para documento pendiente de revisión */
.badge-pending {
  background-color: #BBDEFB !important; /* fondo azul claro */
  color: #0C36B0 !important;            /* texto azul intenso */
}

/* Estilos para el input de fecha en SweetAlert2 */
.swal2-input-centered,
.swal2-input {
  text-align: center !important;
  width: 200px !important;
  padding: 12px !important;
  font-size: 16px !important;
  border: 2px solid #ddd !important;
  border-radius: 8px !important;
  margin: 0 auto !important;
  display: block !important;
}

.swal2-input-centered:focus,
.swal2-input:focus {
  border-color: #3085d6 !important;
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(48, 133, 214, 0.1) !important;
}

/* Estilos específicos para inputs de tipo date - asegurar visibilidad completa */
input[type="date"].swal2-input,
input[type="date"].swal2-input-centered,
.swal2-input[type="date"],
.swal2-date-input {
  text-align: center !important;
  text-align-last: center !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  max-width: 300px !important;
  margin: 10px auto !important;
  padding: 10px !important;
  font-size: 16px !important;
  border: 2px solid #3085d6 !important;
  border-radius: 5px !important;
  background-color: #fff !important;
  color: #000 !important;
  cursor: pointer !important;
  -webkit-appearance: none !important;
  -moz-appearance: textfield !important;
}

/* Asegurar que el contenedor del input también sea visible */
.swal2-input-container {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Estilos para el botón del calendario nativo en inputs de tipo date */
input[type="date"]::-webkit-calendar-picker-indicator {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  cursor: pointer !important;
  width: 20px !important;
  height: 20px !important;
  margin-left: 5px !important;
  background-color: transparent !important;
  color: #3085d6 !important;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-clear-button {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  cursor: pointer !important;
}

/* Para Firefox */
input[type="date"]::-moz-calendar-picker-indicator {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  cursor: pointer !important;
  width: 20px !important;
  height: 20px !important;
  margin-left: 5px !important;
}

/* Clase adicional para centrado */
.text-center {
  text-align: center !important;
}

/* Estilos para el modal de aprobación de documentos */
.swal2-html-container .form-label {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin-bottom: 0.5rem !important;
  font-weight: 500 !important;
}

.swal2-html-container .form-control {
  text-align: center !important;
  margin: 0 auto !important;
  display: block !important;
}

.swal2-html-container .form-text {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin-top: 0.25rem !important;
}

.swal2-html-container .mb-3 {
  text-align: center !important;
}

/* Estilos específicos para el modal de aprobación centrado */
.swal2-html-container-centered .form-label {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin-bottom: 0.5rem !important;
  font-weight: 500 !important;
}

.swal2-html-container-centered .form-control {
  text-align: center !important;
  margin: 0 auto !important;
  display: block !important;
  width: 80% !important;
  max-width: 250px !important;
}

.swal2-html-container-centered .form-text {
  text-align: center !important;
  display: block !important;
  width: 100% !important;
  margin-top: 0.25rem !important;
}

.swal2-html-container-centered .mb-3 {
  text-align: center !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/admin/admin-fiscal-documentation/admin-fiscal-documentation.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,kEAAkE;AAClE;EACE,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,yBAAyB,aAAa,uBAAuB;AAC/D;;AAEA,kDAAkD;AAClD;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA,iFAAiF;AACjF;;;;EAIE,6BAA6B;EAC7B,kCAAkC;EAClC,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,uEAAuE;AACvE;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;AAC/B;;AAEA,sDAAsD;AACtD;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6DAA6D;AAC7D;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;AAChC","sourcesContent":[".card {\n  background-color: #242937;\n  border: 1px solid #f09500;\n  border-radius: 10px;\n  color: white;\n}\n\n.card-title {\n  font-weight: 600;\n  color: #f09500;\n}\n\n.btn-outline-warning {\n  color: #f09500;\n  border-color: #f09500;\n}\n\n.btn-outline-warning:hover {\n  background-color: #f09500;\n  color: #242937;\n}\n\n.btn-warning {\n  background-color: #f09500;\n  border-color: #f09500;\n  color: #242937;\n}\n\n.btn-primary {\n  background-color: #007bff !important;\n  border-color: #007bff !important;\n  color: white !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3 !important;\n  border-color: #0056b3 !important;\n  color: white !important;\n}\n\n.btn-primary:disabled {\n  background-color: #6c757d !important;\n  border-color: #6c757d !important;\n  color: white !important;\n  opacity: 0.65 !important;\n  cursor: not-allowed !important;\n}\n\n.table {\n  color: white;\n}\n\n.table thead th {\n  font-weight: 600;\n  border-color: #3a3f50;\n}\n\n.table tbody td {\n  vertical-align: middle;\n  border-color: #3a3f50;\n}\n\n.text-warning {\n  color: #f09500 !important;\n}\n\n.badge {\n  padding: 8px;\n  font-weight: 500;\n}\n\n.btn-success, .btn-danger {\n  border: none;\n}\n\n.btn-success {\n  background-color: #28a745;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n}\n\n.alert-info {\n  background-color: rgba(13, 202, 240, 0.2);\n  color: white;\n  border-color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.cursor-pointer:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* Estilos para mejorar la apariencia de los botones en la tabla */\n.table td {\n  vertical-align: middle;\n}\n\n/* Contenedor de botones - forzar disposición horizontal */\n.actions-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 4px;\n  min-width: 220px;\n}\n\n/* Cuando los botones necesiten wrap, hacerlo con mejor control */\n@media (max-width: 1200px) {\n  .actions-container {\n    flex-wrap: wrap;\n    min-width: 180px;\n  }\n}\n\n.actions-container .btn {\n  white-space: nowrap;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.4rem;\n  border-radius: 4px;\n  margin: 1px;\n}\n\n/* Colores específicos para cada tipo de botón */\n.actions-container .btn-success {\n  background-color: #28a745;\n  border-color: #28a745;\n  color: white;\n}\n\n.actions-container .btn-danger {\n  background-color: #dc3545;\n  border-color: #dc3545;\n  color: white;\n}\n\n.actions-container .btn-warning {\n  background-color: #ffc107;\n  border-color: #ffc107;\n  color: #212529;\n}\n\n.actions-container .btn-info {\n  background-color: #17a2b8;\n  border-color: #17a2b8;\n  color: white;\n}\n\n.actions-container .btn-primary {\n  background-color: #007bff !important;\n  border-color: #007bff !important;\n  color: white !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.actions-container .btn-primary:hover {\n  background-color: #0056b3 !important;\n  border-color: #0056b3 !important;\n  color: white !important;\n}\n\n.actions-container .btn-outline-danger {\n  border-color: #dc3545;\n  color: #dc3545;\n  background-color: transparent;\n}\n\n.actions-container .btn-outline-danger:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Badge para documento pendiente de revisión */\n.badge-pending {\n  background-color: #BBDEFB !important; /* fondo azul claro */\n  color: #0C36B0 !important;            /* texto azul intenso */\n}\n\n/* Estilos para el input de fecha en SweetAlert2 */\n.swal2-input-centered,\n.swal2-input {\n  text-align: center !important;\n  width: 200px !important;\n  padding: 12px !important;\n  font-size: 16px !important;\n  border: 2px solid #ddd !important;\n  border-radius: 8px !important;\n  margin: 0 auto !important;\n  display: block !important;\n}\n\n.swal2-input-centered:focus,\n.swal2-input:focus {\n  border-color: #3085d6 !important;\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(48, 133, 214, 0.1) !important;\n}\n\n/* Estilos específicos para inputs de tipo date - asegurar visibilidad completa */\ninput[type=\"date\"].swal2-input,\ninput[type=\"date\"].swal2-input-centered,\n.swal2-input[type=\"date\"],\n.swal2-date-input {\n  text-align: center !important;\n  text-align-last: center !important;\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  width: 100% !important;\n  max-width: 300px !important;\n  margin: 10px auto !important;\n  padding: 10px !important;\n  font-size: 16px !important;\n  border: 2px solid #3085d6 !important;\n  border-radius: 5px !important;\n  background-color: #fff !important;\n  color: #000 !important;\n  cursor: pointer !important;\n  -webkit-appearance: none !important;\n  -moz-appearance: textfield !important;\n}\n\n/* Asegurar que el contenedor del input también sea visible */\n.swal2-input-container {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Estilos para el botón del calendario nativo en inputs de tipo date */\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  display: inline-block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  cursor: pointer !important;\n  width: 20px !important;\n  height: 20px !important;\n  margin-left: 5px !important;\n  background-color: transparent !important;\n  color: #3085d6 !important;\n}\n\ninput[type=\"date\"]::-webkit-inner-spin-button,\ninput[type=\"date\"]::-webkit-clear-button {\n  display: inline-block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  cursor: pointer !important;\n}\n\n/* Para Firefox */\ninput[type=\"date\"]::-moz-calendar-picker-indicator {\n  display: inline-block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  cursor: pointer !important;\n  width: 20px !important;\n  height: 20px !important;\n  margin-left: 5px !important;\n}\n\n/* Clase adicional para centrado */\n.text-center {\n  text-align: center !important;\n}\n\n/* Estilos para el modal de aprobación de documentos */\n.swal2-html-container .form-label {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin-bottom: 0.5rem !important;\n  font-weight: 500 !important;\n}\n\n.swal2-html-container .form-control {\n  text-align: center !important;\n  margin: 0 auto !important;\n  display: block !important;\n}\n\n.swal2-html-container .form-text {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin-top: 0.25rem !important;\n}\n\n.swal2-html-container .mb-3 {\n  text-align: center !important;\n}\n\n/* Estilos específicos para el modal de aprobación centrado */\n.swal2-html-container-centered .form-label {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin-bottom: 0.5rem !important;\n  font-weight: 500 !important;\n}\n\n.swal2-html-container-centered .form-control {\n  text-align: center !important;\n  margin: 0 auto !important;\n  display: block !important;\n  width: 80% !important;\n  max-width: 250px !important;\n}\n\n.swal2-html-container-centered .form-text {\n  text-align: center !important;\n  display: block !important;\n  width: 100% !important;\n  margin-top: 0.25rem !important;\n}\n\n.swal2-html-container-centered .mb-3 {\n  text-align: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
